import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@material-ui/core';

const Dropdown = ({ anchorOrigin, renderTrigger, renderContent, transformOrigin, popoverProps }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleTriggerClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const isPopoverOpen = Boolean(anchorEl);

    return (
        <React.Fragment>
            {
                renderTrigger({
                    open: handleTriggerClick,
                    isOpen: isPopoverOpen
                })
            }
            <Popover
                open={isPopoverOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                {...popoverProps}
                >
                {
                    renderContent({
                        close: handlePopoverClose
                    })
                }
            </Popover>
        </React.Fragment>
    );
};

Dropdown.propTypes = {
    anchorOrigin: PropTypes.shape({
        horizontal: PropTypes.string.isRequired,
        vertical: PropTypes.string.isRequired
    }),
    renderTrigger: PropTypes.func.isRequired,
    renderContent: PropTypes.func.isRequired,
    transformOrigin: PropTypes.shape({
        horizontal: PropTypes.string.isRequired,
        vertical: PropTypes.string.isRequired
    }),
    popoverProps: PropTypes.object
};

Dropdown.defaultProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
    },
    popoverProps: {}
};

export default Dropdown;

